import gql from 'graphql-tag';

export const DeleteParticipantTaskTemplate = gql`
  mutation DeleteParticipantTaskTemplate(
    $organizationId: ID!
    $participantTaskTemplateId: ID!
  ) {
    deleteParticipantTaskTemplate(
      organizationId: $organizationId
      participantTaskTemplateId: $participantTaskTemplateId
    ) {
      id
    }
  }
`;
